import { Dictionary } from "types";

export function resolveDynamicVariables<TConfig>(target: string, variables: Dictionary<any>): TConfig {
    const regex = /{{([^}}]+)}}/g;
    const matches = target.match(regex);

    (matches || []).forEach((match: string) => {
        const key = match.substring(2, match.length - 2);
        if (key !== "fileStoreId") {
            const value: any = variables[key];
            if (value === undefined) {
                target = target.replace(match, "");
                console.error(`Could not find a matching value for the specified variable ${match}. Reverting to empty string`);
            } else {
                target = target.replace(match, value);
            }
        }
    });
    return JSON.parse(target as string);
}